/* eslint-disable import/prefer-default-export */
/* eslint-disable max-lines */
/* eslint-disable no-magic-numbers */
/* eslint-disable sort-keys */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.naturaV3Dark = void 0;
/**
 * @todo refactor(styles): replace magic numbers by tokens (including opacity, padding and sizing)
 */
var hex_to_rgba_1 = __importDefault(require("hex-to-rgba"));
var natds_themes_1 = __importDefault(require("@naturacosmeticos/natds-themes"));
var tokens_1 = __importDefault(require("../../tokens"));
var typography_1 = require("./typography");
var typography_2 = require("../../tokens/typography");
var spacing_1 = require("../../tokens/spacing");
var avatarSizes_1 = require("../../tokens/avatarSizes");
var buttonSizes_1 = require("../../tokens/buttonSizes");
var elevation_1 = require("../../tokens/elevation");
var iconSizes_1 = require("../../tokens/iconSizes");
var sizes_1 = require("../../tokens/sizes");
var opacity_1 = require("../../tokens/opacity");
var _a = natds_themes_1.default.natura_v3.dark, borderRadius = _a.borderRadius, color = _a.color, opacity = _a.opacity, asset = _a.asset, button = _a.button;
var 
/**
 * @deprecated `naturaV3DarkColorTokens` are deprecated since v0.20 and will be removed at v1.0.
 * Please use `theme.natura.dark.color` from `natds-themes`.
 */
naturaV3DarkColorTokens = tokens_1.default.colorTokens.naturaV3DarkColorTokens;
exports.naturaV3Dark = {
    asset: asset,
    shape: {
        borderRadius: borderRadius.medium,
        buttonBorderRadius: button.borderRadius,
        badgeBorderRadius: 100
    },
    sizes: sizes_1.sizes,
    avatarSizes: avatarSizes_1.avatarSizes,
    buttonSizes: buttonSizes_1.buttonSizes,
    color: color,
    iconSizes: iconSizes_1.iconSizes,
    /**
     * @since 0.22
     * @todo Adopt opacity tokens from theme and deprecate legacy opacity
     */
    opacity: opacity_1.opacity,
    spacing: spacing_1.spacing.spacing,
    palette: {
        action: {
            /**
             * @since 0.24
             */
            active: (0, hex_to_rgba_1.default)(color.highlight, opacity.mediumHigh),
            disabled: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnSecondary, 0.24)
        },
        /**
         * @since 0.24
         */
        divider: naturaV3DarkColorTokens.colorLowEmphasis,
        primary: {
            main: naturaV3DarkColorTokens.colorPrimary,
            light: naturaV3DarkColorTokens.colorPrimaryLight,
            dark: naturaV3DarkColorTokens.colorPrimaryDark,
            contrastText: naturaV3DarkColorTokens.colorOnPrimary
        },
        secondary: {
            main: naturaV3DarkColorTokens.colorSecondary,
            light: naturaV3DarkColorTokens.colorPrimaryLight,
            dark: naturaV3DarkColorTokens.colorPrimaryDark,
            contrastText: naturaV3DarkColorTokens.colorOnSecondary
        },
        error: {
            main: naturaV3DarkColorTokens.colorAlert,
            contrastText: naturaV3DarkColorTokens.colorOnAlert
        },
        success: {
            main: naturaV3DarkColorTokens.colorSuccess,
            contrastText: naturaV3DarkColorTokens.colorOnSuccess
        },
        background: {
            paper: naturaV3DarkColorTokens.colorSurface,
            default: naturaV3DarkColorTokens.colorBackground,
            paperContrastText: naturaV3DarkColorTokens.colorOnSurface,
            defaultContrastText: naturaV3DarkColorTokens.colorOnBackground
        },
        text: {
            primary: naturaV3DarkColorTokens.colorHighEmphasis,
            secondary: naturaV3DarkColorTokens.colorMediumEmphasis,
            disabled: naturaV3DarkColorTokens.colorLowEmphasis,
            hint: naturaV3DarkColorTokens.colorLowEmphasis
        },
        complementary: {
            highlight: naturaV3DarkColorTokens.colorHighlight,
            link: naturaV3DarkColorTokens.colorLink,
            linkContrastText: naturaV3DarkColorTokens.colorOnLink,
            warning: naturaV3DarkColorTokens.colorWarning,
            warningContrastText: naturaV3DarkColorTokens.colorOnSecondary
        }
    },
    typography: __assign(__assign({}, typography_1.typography), typography_2.fontSize),
    shadows: elevation_1.elevation,
    overrides: {
        MuiButton: {
            outlinedPrimary: {
                color: naturaV3DarkColorTokens.colorHighEmphasis
            },
            outlinedSecondary: {
                color: naturaV3DarkColorTokens.colorHighEmphasis,
                '&.Mui-disabled': {
                    borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D")
                }
            },
            sizeSmall: __assign(__assign({}, buttonSizes_1.buttonSizes.small), typography_2.fontSize.subtitle2),
            root: __assign(__assign({}, buttonSizes_1.buttonSizes.medium), typography_2.fontSize.subtitle2),
            sizeLarge: __assign(__assign({}, buttonSizes_1.buttonSizes.large), typography_2.fontSize.subtitle2),
            text: {
                padding: null,
                '&.Mui-disabled': {
                    color: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D"),
                    borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D")
                }
            },
            contained: {
                '&.Mui-disabled': {
                    color: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D"),
                    backgroundColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "14")
                }
            },
            outlined: {
                padding: null,
                borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D"),
                '&.Mui-disabled': {
                    color: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D"),
                    borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D")
                }
            }
        },
        MuiAvatar: {
            colorDefault: {
                color: naturaV3DarkColorTokens.colorHighEmphasis
            }
        },
        MuiIconButton: {
            root: {
                color: naturaV3DarkColorTokens.colorHighEmphasis,
                padding: '8px'
            },
            sizeSmall: {
                padding: '4px'
            }
        },
        MuiExpansionPanel: {
            root: {
                border: 'transparent 1px solid',
                '&$expanded': {
                    borderColor: naturaV3DarkColorTokens.colorPrimary
                },
                '&$disabled': {
                    backgroundColor: naturaV3DarkColorTokens.colorSurface,
                    opacity: 0.32
                }
            }
        },
        MuiExpansionPanelSummary: {
            root: {
                alignItems: 'flex-start',
                marginTop: '8px',
                '&$disabled': {
                    opacity: 1
                }
            }
        },
        MuiToolbar: {
            root: {
                padding: '0 16px',
                '@media (min-width: 600px)': {
                    padding: '0 16px'
                }
            },
            gutters: {
                padding: '0 16px',
                '@media (min-width: 600px)': {
                    padding: '0 16px'
                }
            },
            regular: {
                minHeight: '56px',
                '@media (min-width: 600px)': {
                    minHeight: '56px'
                }
            },
            dense: {
                minHeight: '56px',
                '@media (min-width: 600px)': {
                    minHeight: '56px'
                }
            }
        },
        MuiListItem: {
            root: {
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorHighEmphasis, 0.04)
                },
                '&$selected': {
                    backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorPrimary, 0.16),
                    '&:hover': {
                        backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnSecondary, 0.04)
                    },
                    '&:focus': {
                        outline: 'none'
                    }
                },
                '&.Mui-disabled': {
                    opacity: 0.32
                }
            },
            gutters: {
                '&:focus': {
                    outline: 'none'
                }
            },
            button: {
                '&:hover': {
                    backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnSecondary, 0.04)
                }
            }
        },
        MuiBadge: {
            badge: {
                padding: '0 4px'
            }
        },
        MuiTab: {
            root: {
                '&$disabled': {
                    opacity: 0.24
                }
            },
            textColorInherit: {
                '&$disabled': {
                    opacity: 0.24
                }
            },
            wrapper: {
                '& > *:first-child': {
                    marginBottom: '2px !important'
                }
            }
        },
        MuiChip: {
            root: {
                backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnBackground, 0.12),
                color: naturaV3DarkColorTokens.colorOnBackground,
                fontSize: typography_2.fontSize.subtitle2.fontSize,
                '& $avatar': {
                    backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnBackground, 0.24),
                    color: naturaV3DarkColorTokens.colorOnBackground
                },
                '&$disabled': {
                    opacity: 0.4
                }
            },
            clickable: {
                '&:hover': {
                    backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnBackground, 0.16)
                },
                '&:focus': {
                    backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnBackground, 0.16)
                }
            },
            clickableColorPrimary: {
                '&:hover': {
                    backgroundColor: naturaV3DarkColorTokens.colorPrimaryDark
                }
            },
            clickableColorSecondary: {
                '&:hover': {
                    backgroundColor: naturaV3DarkColorTokens.colorPrimaryDark
                }
            },
            outlined: {
                borderColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnBackground, 0.12),
                color: naturaV3DarkColorTokens.colorOnBackground
            },
            outlinedPrimary: {
                color: naturaV3DarkColorTokens.colorOnBackground,
                '& $avatar': {
                    backgroundColor: naturaV3DarkColorTokens.colorPrimary
                }
            },
            outlinedSecondary: {
                color: naturaV3DarkColorTokens.colorOnBackground,
                '& $avatar': {
                    backgroundColor: naturaV3DarkColorTokens.colorSecondary
                }
            },
            icon: {
                fontSize: "".concat(sizes_1.sizes.standard, "px")
            },
            iconSmall: {
                width: "".concat(sizes_1.sizes.small, "px"),
                height: "".concat(sizes_1.sizes.small, "px"),
                fontSize: "".concat(sizes_1.sizes.small, "px"),
                marginTop: '1px'
            },
            deleteIcon: {
                width: "".concat(sizes_1.sizes.standard, "px"),
                height: "".concat(sizes_1.sizes.standard, "px"),
                fontSize: "".concat(sizes_1.sizes.standard, "px"),
                color: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnBackground, 0.8),
                '&:hover': {
                    color: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnBackground, 0.6)
                }
            },
            deleteIconSmall: {
                width: "".concat(sizes_1.sizes.small, "px"),
                height: "".concat(sizes_1.sizes.small, "px"),
                fontSize: "".concat(sizes_1.sizes.small, "px")
            },
            deleteIconColorPrimary: {
                color: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnBackground, 0.8),
                '&:hover': {
                    color: naturaV3DarkColorTokens.colorOnBackground
                }
            },
            deleteIconColorSecondary: {
                color: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorOnBackground, 0.8),
                '&:hover': {
                    color: naturaV3DarkColorTokens.colorOnBackground
                }
            }
        },
        MuiTextField: {
            '& .MuiInputLabel': {
                marginTop: '20px'
            }
        },
        MuiInputBase: {
            root: {
                fontSize: typography_2.fontSize.subtitle2.fontSize,
                borderRadius: '4px',
                boxShadow: "".concat(naturaV3DarkColorTokens.colorLowEmphasis, " 0 0 0 1px"),
                color: naturaV3DarkColorTokens.colorHighEmphasis,
                width: '100%',
                "&[data-state='error']": {
                    boxShadow: "".concat(naturaV3DarkColorTokens.colorAlert, " 0 0 0 1px")
                },
                "&[data-state='success']": {
                    boxShadow: "".concat(naturaV3DarkColorTokens.colorSuccess, " 0 0 0 1px")
                },
                '&:hover': {
                    boxShadow: "".concat(naturaV3DarkColorTokens.colorMediumEmphasis, " 0 0 0 1px"),
                    '&.Mui-disabled': {
                        boxShadow: "".concat(naturaV3DarkColorTokens.colorLowEmphasis, " 0 0 0 1px")
                    }
                },
                '&.Mui-focused': {
                    boxShadow: "".concat(naturaV3DarkColorTokens.colorPrimary, " 0 0 0 2px")
                },
                '&.MuiFilled:not(.Mui-focused)': {
                    boxShadow: "".concat(naturaV3DarkColorTokens.colorHighEmphasis, " 0 0 0 1px"),
                    '&:hover': {
                        boxShadow: "".concat(naturaV3DarkColorTokens.colorMediumEmphasis, " 0 0 0 1px")
                    }
                },
                '&.MuiInputBase-multiline': {
                    padding: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.none
                },
                '&.MuiInput-underline:before': {
                    borderBottom: 'none'
                },
                '&.MuiInput-underline.Mui-disabled:before': {
                    borderBottomStyle: 'none'
                },
                '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottom: 'none'
                },
                '&.MuiInput-underline:after': {
                    borderBottom: 'none'
                }
            },
            adornedEnd: {
                paddingRight: sizes_1.sizes.medium
            },
            input: {
                '&.Mui-disabled:not(::placeholder)': {
                    opacity: 0.24
                },
                '&::placeholder': {
                    color: naturaV3DarkColorTokens.colorMediumEmphasis
                },
                '&.MuiInput-inputTypeSearch': {
                    paddingRight: sizes_1.sizes.large
                },
                border: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.none,
                boxSizing: 'border-box',
                lineHeight: "".concat(sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.standard, "px"),
                minHeight: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.mediumX,
                padding: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.small
            },
            inputMultiline: {
                padding: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.small
            },
            inputTypeSearch: {
                '&::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration': {
                    display: 'none'
                }
            }
        },
        MuiInputAdornment: {
            root: {
                position: 'absolute',
                right: '0'
            },
            positionEnd: {
                marginRight: spacing_1.spacing.spacingTiny
            }
        },
        MuiInputLabel: {
            formControl: {
                position: 'relative',
                transform: 'none',
                marginTop: '-4px'
            },
            shrink: {
                transform: 'none',
                marginTop: '-4px'
            }
        },
        MuiFormLabel: {
            root: {
                fontSize: typography_2.fontSize.subtitle2.fontSize,
                '&.Mui-focused': {
                    fontSize: typography_2.fontSize.subtitle2.fontSize,
                    color: naturaV3DarkColorTokens.colorMediumEmphasis
                },
                '&.Mui-error': {
                    color: naturaV3DarkColorTokens.colorHighEmphasis
                }
            }
        },
        MuiFormHelperText: {
            root: {
                '&.Mui-error': {
                    color: naturaV3DarkColorTokens.colorMediumEmphasis
                }
            }
        },
        MuiSelect: {
            select: {
                '&:focus': {
                    backgroundColor: 'transparent'
                },
                '&.Mui-disabled': {
                    color: naturaV3DarkColorTokens.colorLowEmphasis
                }
            },
            icon: {
                top: sizes_1.sizes.micro,
                color: naturaV3DarkColorTokens.colorHighEmphasis
            }
        },
        MuiButtonGroup: {
            groupedOutlinedHorizontal: {
                '&:not(:first-child)': {
                    marginLeft: 'none'
                }
            },
            groupedContainedPrimary: {
                '&:not(:last-child)': {
                    borderColor: naturaV3DarkColorTokens.colorPrimaryDark,
                    '&.Mui-disabled': {
                        borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D")
                    }
                }
            },
            groupedContainedSecondary: {
                '&:not(:last-child)': {
                    borderColor: naturaV3DarkColorTokens.colorSecondaryDark,
                    '&.Mui-disabled': {
                        borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D")
                    }
                }
            },
            groupedContainedHorizontal: {
                '&:not(:last-child)': {
                    borderRightColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "1F"),
                    '&.Mui-disabled': {
                        borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D")
                    }
                }
            },
            groupedTextPrimary: {
                '&:not(:last-child).Mui-disabled': {
                    borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D")
                }
            },
            groupedTextSecondary: {
                '&:not(:last-child).Mui-disabled': {
                    borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D")
                }
            },
            groupedTextHorizontal: {
                '&:not(:last-child)': {
                    borderRightColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "1F"),
                    '&.Mui-disabled': {
                        borderColor: "".concat(naturaV3DarkColorTokens.colorHighlight, "3D")
                    }
                }
            }
        },
        MuiSvgIcon: {
            root: {
                fill: naturaV3DarkColorTokens.colorMediumEmphasis
            }
        },
        MuiAlert: {
            root: __assign({ width: 278, padding: spacing_1.spacing.spacingSmall }, typography_2.fontSize.body1),
            icon: {
                marginRight: spacing_1.spacing.spacingTiny
            },
            message: {
                padding: '5px 0'
            },
            standardSuccess: {
                color: naturaV3DarkColorTokens.colorHighEmphasis,
                backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorSuccess, 0.16)
            },
            outlinedSuccess: {
                color: naturaV3DarkColorTokens.colorHighEmphasis
            },
            standardError: {
                color: naturaV3DarkColorTokens.colorHighEmphasis,
                backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorAlert, 0.16)
            },
            outlinedError: {
                color: naturaV3DarkColorTokens.colorHighEmphasis
            },
            standardWarning: {
                color: naturaV3DarkColorTokens.colorHighEmphasis,
                backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorWarning, 0.16),
                '& .MuiAlert-icon': {
                    color: naturaV3DarkColorTokens.colorWarning
                }
            },
            outlinedWarning: {
                color: naturaV3DarkColorTokens.colorHighEmphasis,
                borderColor: naturaV3DarkColorTokens.colorWarning,
                '& .MuiAlert-icon': {
                    color: naturaV3DarkColorTokens.colorWarning
                }
            },
            filledWarning: {
                color: naturaV3DarkColorTokens.colorOnWarning,
                backgroundColor: naturaV3DarkColorTokens.colorWarning
            },
            standardInfo: {
                color: naturaV3DarkColorTokens.colorHighEmphasis,
                backgroundColor: (0, hex_to_rgba_1.default)(naturaV3DarkColorTokens.colorLink, 0.16),
                '& .MuiAlert-icon': {
                    color: naturaV3DarkColorTokens.colorLink
                }
            },
            outlinedInfo: {
                color: naturaV3DarkColorTokens.colorHighEmphasis,
                borderColor: naturaV3DarkColorTokens.colorLink,
                '& .MuiAlert-icon': {
                    color: naturaV3DarkColorTokens.colorLink
                }
            },
            filledInfo: {
                backgroundColor: naturaV3DarkColorTokens.colorLink
            }
        },
        MuiAlertTitle: {
            root: __assign({}, typography_2.fontSize.h6)
        },
        MuiTableSortLabel: {
            icon: {
                marginLeft: spacing_1.spacing.spacing
            }
        },
        MuiTablePagination: {
            root: {
                overflow: 'visible',
                '& .MuiSelect-icon': {
                    top: 0,
                    height: '100%'
                }
            },
            input: {
                flexShrink: 'initial'
            }
        }
    }
};
//# sourceMappingURL=natura_v3-dark.js.map